import { type TypePolicy } from '@apollo/client';

export const CumulativeVocabWord: TypePolicy = {
    fields: {
        audioUrls: {
            merge: true,
        },
    },
};
